module.exports = __webpack_public_path__ + "img/claimproses.e0fb64d2.svg";